import { useEffect, useRef } from 'react';
/**
 * Хук для обработки кликов вне указанного элемента
 *
 * @param handler - Функция, вызываемая при клике вне элемента
 * @param enabled - Флаг включения/выключения обработчика (по умолчанию true)
 * @returns Ref для элемента, который нужно отслеживать
 */
export const useClickOutside = (handler, enabled = true) => {
    const ref = useRef(null);
    useEffect(() => {
        if (!enabled)
            return;
        const handleClickOutside = (event) => {
            if (ref.current && !ref.current.contains(event.target)) {
                handler();
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [handler, enabled]);
    return ref;
};
